import React, { useState } from "react";
import styles from "./Inputs.module.scss";

const EmailInput = ({ label, name, value, onChange, placeholder,required }) => {
  const [error, setError] = useState("");

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    onChange(e);
    
    if (!validateEmail(newValue) && newValue !== "") {
      setError("Error");
    } else {
      setError("");
    }
  };

  return (
    <div className={styles.inputContainer}>
      <label className={styles.label}>
        {label} 
        {required&&<span className={styles.required}>*</span>}
      </label>
      <input
        type="email"
        name={name}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className={`${styles.inputField} ${error ? styles.inputError : ""}`}
      />
      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
};

export default EmailInput;
